import { ObservableArray, View, ViewModel } from "binder";
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export enum ProductType {
    "FinalGood" = 1, "RawMaterial" = 2, "SemiFinalGood" = 3
}


export class ProductSelector extends SearchableSelectorBaseViewModel<product> {
    constructor(parent: ViewModel, productType?: ProductType) {
        super(parent);
        this.productType = productType;
    }

    public set productType(v: number) { this._productType = v; } public get productType(): number { return this._productType; } private _productType: number;

    protected async loadById(id: string): Promise<product> {
        let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/SearchProductsById', {
            Id: id
        });
        return this.convertSingle(result.Product);
    }

    protected async loadData(searchedText: string): Promise<product[]> {
        let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/SearchOrFindProduct', {
            SearchText: searchedText,
            ResultCount: 10,
            ProductType: this.productType
        });
        return result.Products.map(x => this.convertSingle(x));
    }

    private convertSingle(dto: any): product {
        var p = new product(this);
        p.id = dto.Id;
        p.name = dto.ProductName;
        p.code = dto.ProductCode;
        p.groupId = dto.ProductGroupId;
        p.groupName = dto.ProductGroupName;
        p.title = stringIsNullOrEmpty(dto.ProductGroupName) ? `${dto.ProductName} (${dto.ProductCode})` : `${dto.ProductName} (${dto.ProductCode} | ${dto.ProductGroupName})`;
        p.measuredProducts.update(...dto.MeasuredProducts.map(x => {
            let y = new measuredProductDto(this);
            y.unitName = x.UnitName;
            y.unitId = x.UnitId;
            y.id = x.MeasuredProductId;
            return y;
        }));
        return p;
    }
}

export class product extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.measuredProducts = ObservableArray.create();
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
    public set groupId(v: string) { this._groupId = v; } public get groupId(): string { return this._groupId;} private _groupId: string;
    public set groupName(v: string) { this._groupName = v; } public get groupName(): string { return this._groupName;} private _groupName: string;
    public set measuredProducts(v: ObservableArray<measuredProductDto>) { this._measuredProducts = v; } public get measuredProducts(): ObservableArray<measuredProductDto> { return this._measuredProducts; } private _measuredProducts: ObservableArray<measuredProductDto>;
}

export class measuredProductDto extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set unitId(v: string) { this._unitId = v; } public get unitId(): string { return this._unitId; } private _unitId: string;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;

}
